export default __webpack_public_path__ + "static/media/115.82ac85fb.png";